import * as types from './actionTypes';
import axios from 'axios';
import {getHeader} from '../helper';

function receiveEquipment(data) {
    return {
        type: types.LOAD_EQUIPMENT_SUCCESS,
        data: data
    }
}

function requestEquipment() {
    return {
        type: types.LOAD_EQUIPMENT_REQUEST
    }
}

function equipmentError(messages) {
    return {
        type: types.LOAD_EQUIPMENT_FAILURE,
        messages
    }
}

export function getEquipment(args, callback) {
    let defaultSettings = {
        url: `${window.siteUrl}/api/v1/camera/`,
        params: {},
        headers: {},
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,
            ...args.params
        }
    });
    
    return function (dispatch) {
        dispatch(requestEquipment())

        return axios.get(newSettings.url, {
            params: newSettings.params,
            headers: newSettings.headers
        })
        .then(function (response) {
            // console.log("load equipment data-", response.data)
            dispatch(receiveEquipment(response.data));

            callback();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("load equipment error-", err.data, err.status, err.headers);
                dispatch(equipmentError(err.data));
            }
        });
    }
}

export function getEquipmentById(args, callback) {
    let defaultSettings = {
        url: `${window.siteUrl}/api/v1/camera/`,
        params: {},
        headers: {},
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,
            ...args.params
        }
    });
    
    return function (dispatch) {
        dispatch(requestEquipment())

        return axios.get(newSettings.url, {
            params: newSettings.params,
            headers: newSettings.headers
        })
        .then(function (response) {
            // console.log("load equipmentById data-", response.data)
            dispatch(receiveEquipment({
                results: [
                    response.data
                ]
            }));

            callback();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("load equipmentById error-", err.data, err.status, err.headers);
                dispatch(equipmentError(err.data));
            }
        });
    }
}


function receiveMoreEquipment(data) {
    return {
        type: types.LOAD_MORE_EQUIPMENT_SUCCESS,
        data: data
    }
}

function requestMoreEquipment() {
    return {
        type: types.LOAD_MORE_EQUIPMENT_REQUEST
    }
}

function moreEquipmentError(messages) {
    return {
        type: types.LOAD_MORE_EQUIPMENT_FAILURE,
        messages
    }
}

export function getMoreEquipment(args) {
    let defaultSettings = {
        params: {},
        headers: {}
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,
            ...args.params
        }
    });

    return function (dispatch) {
        dispatch(requestMoreEquipment())

        return axios.get(`${window.siteUrl}/api/v1/camera/`, {
            params: newSettings.params,
            headers: newSettings.headers
        })
        .then(function (response) {
            // console.log("more Equipment creator data-", response.data)
            dispatch(receiveMoreEquipment(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("more Equipment creator error-", err.data, err.status, err.headers);
                dispatch(moreEquipmentError(err.data));
            }
        });
    }
}


function receiveCreateEquipment(data) {
    return {
        type: types.CREATE_EQUIPMENT_SUCCESS,
        data: data
    }
}

function requestCreateEquipment() {
    return {
        type: types.CREATE_EQUIPMENT_REQUEST
    }
}

function createEquipmentError(messages) {
    return {
        type: types.CREATE_EQUIPMENT_FAILURE,
        messages
    }
}

export function createEquipment(params, callback) {
    return function (dispatch) {
        dispatch(requestCreateEquipment())

        return axios.post(
            `${window.siteUrl}/api/v1/camera/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log("create Equipment creator data-", response.data)
            dispatch(receiveCreateEquipment(response.data));

            callback();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("create Equipment creator error-", err.data, err.status, err.headers);
                dispatch(createEquipmentError(err.data));
            }
        });
    }
}


function receiveDeleteEquipment(data) {
    return {
        type: types.DELETE_EQUIPMENT_SUCCESS,
        data: data
    }
}

function requestDeleteEquipment() {
    return {
        type: types.DELETE_EQUIPMENT_REQUEST
    }
}

function deleteEquipmentError(messages) {
    return {
        type: types.DELETE_EQUIPMENT_FAILURE,
        messages
    }
}

export function deleteEquipment(equipmentId, params, callback) {
    return function (dispatch) {
        dispatch(requestDeleteEquipment());

        return axios.patch(
            `${window.siteUrl}/api/v1/camera/${equipmentId}/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log("delete Equipment creator data-", response.data)
            dispatch(receiveDeleteEquipment(response.data));

            if(callback) callback();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("delete Equipment creator error-", err.data, err.status, err.headers);
                dispatch(deleteEquipmentError(err.data));
            }
        });
    }
}


function receiveUpdateEquipment(data) {
    return {
        type: types.UPDATE_EQUIPMENT_SUCCESS,
        data: data
    }
}

function requestUpdateEquipment() {
    return {
        type: types.UPDATE_EQUIPMENT_REQUEST
    }
}

function updateEquipmentError(messages) {
    return {
        type: types.UPDATE_EQUIPMENT_FAILURE,
        messages
    }
}

export function updateEquipment(equipmentId, params, callback) {
    return function (dispatch) {
        dispatch(requestUpdateEquipment());

        return axios.patch(
            `${window.siteUrl}/api/v1/camera/${equipmentId}/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            // console.log("update Equipment creator data-", response.data)
            dispatch(receiveUpdateEquipment(response.data));

            callback();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("update Equipment creator error-", err.data, err.status, err.headers);
                dispatch(updateEquipmentError(err.data));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/equipmentActions.js